import { render, staticRenderFns } from "./edit_department_model.vue?vue&type=template&id=1ea6b630&scoped=true&"
import script from "./edit_department_model.vue?vue&type=script&lang=js&"
export * from "./edit_department_model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea6b630",
  null
  
)

export default component.exports